<template>
  <div id="map">
    <div id="allmap">
    </div>
  </div>
</template>

<script>
  export default {
    data:function(){
      return{
        mapStyle:{
          width:'100%',
          height:this.mapHeight +'px'
        }
      }
    },
    props:{
      // 地图在该视图上的高度
      mapHeight:{
        type:Number,
        default:500
      },
      // 经度
      longitude:{
        type:Number,
        default:116.332935,
      },
      // 纬度
      latitude:{
        type:Number,
        default:40.067494
      },
      description:{
        type:String,
        default:'速得尔科技（北京）有限公司'
      }
    },
    mounted(){
        //       // 百度地图API功能
        // var map = new BMap.Map('allmap');
        // var poi = new BMap.Point(116.332935,40.067494);
        // map.centerAndZoom(poi, 16);
        // map.enableScrollWheelZoom();

        // var content = '<div style="margin:0;line-height:20px;padding:2px;">' +
        //   '<img src="../../static/suooter.png" alt="" style="float:right;zoom:1;overflow:hidden;width:100px;height:100px;margin-left:3px;"/>' +
        //   '地址：北京市昌平区西三旗桥北金燕龙大厦301<br/>电话：4006-747-313<br/>速得尔，以创新技术服务中国射击事业！' +
        //   '</div>';

        // //创建检索信息窗口对象
        // var searchInfoWindow = null;
        // searchInfoWindow = new BMapLib.SearchInfoWindow(map, content, {
        //   title  : "速得尔科技（北京）有限公司",      //标题
        //   width  : 290,             //宽度
        //   height : 105,              //高度
        //   panel  : "panel",         //检索结果面板
        //   enableAutoPan : true,     //自动平移
        //   searchTypes   :[
        //     BMAPLIB_TAB_SEARCH,   //周边检索
        //     BMAPLIB_TAB_TO_HERE,  //到这里去
        //     BMAPLIB_TAB_FROM_HERE //从这里出发
        //   ]
        // });
        // var marker = new BMap.Marker(poi); //创建marker对象
        // marker.enableDragging(); //marker可拖拽
        // searchInfoWindow.open(marker);
        // marker.addEventListener("click", function(e){
        //   searchInfoWindow.open(marker);
        // })
        // map.addOverlay(marker); //在地图中添加marker

    }
  }

</script>
<style lang="less">
  #map{
    width:inherit;
    height:inherit;
  }
  #allmap{
    width:512px;
    height:351px;
  }
</style>



// WEBPACK FOOTER //
// src/components/commap.vue